import React from 'react';

const uspItems = [
  { icon: 'fa-microchip', title: 'Latest Printing', sub: 'Technology' },
  { icon: 'fa-palette', title: 'Vibrant Colors &', sub: 'Premium Quality' },
  { icon: 'fa-boxes', title: 'Bulk Order', sub: 'Discounts' },
  { icon: 'fa-shipping-fast', title: 'On-time Delivery', sub: 'Every Time' },
  { icon: 'fa-headset', title: '100% Customer', sub: 'Support' },
];

const UspStrip: React.FC = () => (
  <div className="usp-strip d-flex flex-wrap justify-content-around gap-3">
    {uspItems.map((item, i) => (
      <div className="usp-item" key={i}>
        <i className={`fas ${item.icon}`}></i>
        <div className="usp-text">
          {item.title}<span>{item.sub}</span>
        </div>
      </div>
    ))}
  </div>
);

export default UspStrip;
